package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RecentActionEntry(
    val id: String,
    @SerialName("admin_name") val adminName: String?,
    val action: String,
    @SerialName("target_type") val targetType: String?,
    @SerialName("target_id") val targetId: String?,
    @SerialName("target_name") val targetName: String?,
    val reason: String?,
    @SerialName("created_at") val createdAt: String
)
